import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Avatar,
  Typography,
  Button,
} from '@mui/material'
import { Twitter } from '@mui/icons-material'
import axios from 'axios'

function TwitterDashboard({ userData, handleLogout }) {
  const [twitterData, setTwitterData] = useState(null)
  const navigate = useNavigate()

  const defaultBackendUrl =
    typeof window !== 'undefined' ? window.location.origin : ''
  const backendUrl =
    process.env.REACT_APP_BACKEND_URL || defaultBackendUrl

  useEffect(() => {
    axios
      .get(`${backendUrl}/me`, { withCredentials: true })
      .then((response) => {
        setTwitterData(response.data)
      })
      .catch((err) => {
        console.error('Error fetching Twitter user data:', err)
      })
  }, [backendUrl])

  useEffect(() => {
    if (!userData) {
      navigate('/')
    }
  }, [userData, navigate])

  if (!twitterData) {
    return <div>Loading Twitter Dashboard...</div>
  }

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: '100vh' }}
    >
      <Grid item lg={5} md={6} xs={12}>
        <Card elevation={3}>
          <CardHeader
            title="User Information"
            titleTypographyProps={{ variant: 'h5' }}
            avatar={
              <Avatar
                src={twitterData.profile_image_url}
                alt={twitterData.name}
                variant="circle"
              />
            }
          />
          <CardContent>
            <Typography variant="subtitle1" gutterBottom>
              Hey {twitterData.name}, You are now logged in via Twitter!
            </Typography>
            <Typography variant="body2" gutterBottom>
              Twitter Handle: @{twitterData.screen_name}
            </Typography>
            <Typography variant="body2" gutterBottom>
              Twitter ID: {twitterData.twitter_user_id}
            </Typography>

            <Button
              variant="contained"
              color="secondary"
              onClick={handleLogout}
              startIcon={<Twitter />}
              fullWidth
              style={{ marginTop: '10px' }}
            >
              Logout (Service Remains Active)
            </Button>

            <p className="user-profile-text" style={{ marginTop: '16px' }}>
              Thank you for authorising Threat Matrix Direct Messaging Services.
            </p>
            <p className="user-profile-text">
              You will be contacted periodically to remind you that the service
              is running.
            </p>
            <p className="user-profile-text">
              You may opt out of the service at any time by emailing
              threatmatrix@signify.ai
            </p>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default TwitterDashboard
